import { PaymentResource } from '../../shared/models/orders/payment-templates.token';

export class ProviderUiActionResponse {
  Success: boolean;
  OrderId: string;
  Amount: number;
  ErrorCode: string;
  ErrorMessage: string;
  ProviderActionInformation: ProviderActionModel;
}

export class ProviderActionModel {
  FormId: string;
  Form: string;
  Url: string;
  TargetName: string;
  ActionKind: ProviderActionKind;
  NextAction: ProviderNextActionKind;
  Scripts: Array<string>;
  Javascript: string;
  Resources: Array<PaymentResource>;
  ProviderId: number | string;
}

export enum ProviderActionKind {
  /// No Action is required
  None = 0,

  /// Post Form using the Form
  PostForm = 1,

  /// Redirect using the URL
  RedirectUrl = 2,

  /// Create IFrame Modal using the URL
  IframeModalRedirect = 3,

  /// Create IFrame Modal post using the url
  IframeModalPostRedirect = 4,

  /// Create IFrame using the URL
  IframeRedirect = 5,

  /// Create IFrame post using the url
  IframePostRedirect = 6,

  /// Render Content to the page
  RenderContent = 7,

  /// Render the Content to an IFrame
  RenderContentToIFrame = 8,

  /// Render a specific integration
  RenderSpecificIntegration = 9,
}

export enum ProviderNextActionKind {
  /// No Action Required
  None = 0,

  /// Need to make contact with the payment gateway
  ContactPaymentGateway = 10,

  /// Require more information about shipping
  RequireShippingInformation = 20,

  /// Require customer to provide address information
  RequireAddressInformation = 30,

  /// Validate the user's address before proceeding with purchase
  ValidateDefaultAddressUponPurchase = 40,
}
